<template>
  <VDialogV3
    ref="vDialogRef"
    id="product-code-mapping-card"
    position="right"
    :context-menu="ProductCodeMappingsService.contextMenu"
    width="600px"

    :entity="localProductCodeMapping"

    :errors="errors"

    @submit="submit"
  >
    <section>
      <VInput
        ref=""
        layout="vertical"
        label="Код продукта из номенклатуры КСЗ"
        :max-length="30"
        v-model="localProductCodeMapping.productCodeKsz"
        :validate-method="validateCountFilledFields"
      />

      <VInput
        ref=""
        layout="vertical"
        label="Код продукта из номенклатуры НМГ"
        :max-length="30"
        v-model="localProductCodeMapping.productCodeNmg"
        :validate-method="validateCountFilledFields"
      />
    </section>
    <hr>
    <section>
      <VInput
        ref=""
        layout="vertical"
        label="ТН ВЭД РФ"
        :max-length="20"
        v-model="localProductCodeMapping.hsCodeRu"
        :validate-method="validateCountFilledFields"
      />

      <VInput
        ref=""
        layout="vertical"
        label="ТН ВЭД Узбекистана"
        :max-length="20"
        v-model="localProductCodeMapping.hsCodeUz"
        :validate-method="validateCountFilledFields"
      />
    </section>
  </VDialogV3>
</template>

<script lang="ts">
import ProductCodeMappingsService from "@/domains/ProductCodeMappings/ProductCodeMappingsService";
import ProductCodeMapping from "@/domains/ProductCodeMappings/ProductCodeMapping";

export default defineComponent({
  name: 'ProductCodeMappingCard',

  props: {
    id: {
      type: Number,
      default: null
    },

    productCodeMapping: {
      type: ProductCodeMapping as PropType<ProductCodeMapping>,
      default: null
    }
  },

  setup() {
    return {
      ProductCodeMappingsService,
    }
  },

  data() {
    return {
      localProductCodeMapping: null as ProductCodeMapping|null,
      isEditMode: false,
      errors: []
    }
  },

  async mounted() {
    await this.init();
  },

  methods: {
    async init() {
      const id = this.productCodeMapping?.id ?? this.id ?? null;

      if (id !== null) {
        this.localProductCodeMapping = await ProductCodeMappingsService.get({ id });
        this.isEditMode = true;
      }
      else {
        this.localProductCodeMapping = ProductCodeMapping.fromNew();
      }
    },

    async submit() {
      if (this.localProductCodeMapping === null) return;

      const response = this.isEditMode ?
        await ProductCodeMappingsService.update(this.localProductCodeMapping) :
        await ProductCodeMappingsService.add(this.localProductCodeMapping);

      this.$core.dialogs.ProductCodeMappingCard.resolve();
    },

    validateCountFilledFields() {
      if (this.localProductCodeMapping.validate() === false) {
        if (this.errors.length === 0) {
          this.errors.push({message: 'Два любых поля должны быть заполнены обязательно'});
        }
      }
      else {
        this.errors = [];
      }
    }
  },
});
</script>
